// import Footer from '../react-bootstrap/Footer';
import * as React from 'react';
import '../styles/Footer.scss';

function Footer() {
  return (
    <>
      <br></br>
      <footer className='footer'>Designed and Built by Abby</footer>
    </>
  );
}

export default Footer;
